var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54e1fctlza)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1 29.9a9.426 9.426 0 0 1-3.171-.586 5.305 5.305 0 0 1-1.964-1.278 5.265 5.265 0 0 1-1.279-1.963 9.428 9.428 0 0 1-.586-3.171c-.083-1.8-.1-2.34-.1-6.902s.018-5.1.1-6.901a9.48 9.48 0 0 1 .586-3.17 5.326 5.326 0 0 1 1.278-1.965 5.273 5.273 0 0 1 1.964-1.278A9.427 9.427 0 0 1 9.099 2.1C10.9 2.017 11.441 2 16 2c4.56 0 5.1.018 6.901.1a9.48 9.48 0 0 1 3.171.586c.742.274 1.413.71 1.964 1.278a5.289 5.289 0 0 1 1.278 1.964 9.426 9.426 0 0 1 .587 3.171c.082 1.802.1 2.341.1 6.901s-.018 5.1-.1 6.902a9.471 9.471 0 0 1-.587 3.17 5.655 5.655 0 0 1-3.242 3.242 9.426 9.426 0 0 1-3.171.587c-1.8.082-2.341.1-6.902.1-4.56 0-5.1-.017-6.9-.1",
    fill: "url(#nieromsd5b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 29.9a9.426 9.426 0 0 1-3.171-.586 5.305 5.305 0 0 1-1.964-1.278 5.265 5.265 0 0 1-1.279-1.963 9.428 9.428 0 0 1-.586-3.171c-.083-1.8-.1-2.34-.1-6.902s.018-5.1.1-6.901a9.48 9.48 0 0 1 .586-3.17 5.326 5.326 0 0 1 1.278-1.965 5.273 5.273 0 0 1 1.964-1.278A9.427 9.427 0 0 1 9.099 2.1C10.9 2.017 11.441 2 16 2c4.56 0 5.1.018 6.901.1a9.48 9.48 0 0 1 3.171.586c.742.274 1.413.71 1.964 1.278a5.289 5.289 0 0 1 1.278 1.964 9.426 9.426 0 0 1 .587 3.171c.082 1.802.1 2.341.1 6.901s-.018 5.1-.1 6.902a9.471 9.471 0 0 1-.587 3.17 5.655 5.655 0 0 1-3.242 3.242 9.426 9.426 0 0 1-3.171.587c-1.8.082-2.341.1-6.902.1-4.56 0-5.1-.017-6.9-.1",
    fill: "url(#1ke9xy8usc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.562 16.06a3.466 3.466 0 1 1 6.933 0 3.466 3.466 0 0 1-6.933 0zm-1.874 0a5.342 5.342 0 1 0 10.683 0 5.342 5.342 0 0 0-10.683 0zm9.646-5.553a1.248 1.248 0 1 0 2.494 0 1.248 1.248 0 0 0-2.494 0zm-8.507 14.02a5.75 5.75 0 0 1-1.932-.357 3.444 3.444 0 0 1-1.974-1.974 5.743 5.743 0 0 1-.357-1.931c-.05-1.097-.06-1.426-.06-4.204 0-2.778.01-3.106.06-4.204.008-.66.129-1.313.357-1.932a3.442 3.442 0 0 1 1.974-1.974 5.744 5.744 0 0 1 1.932-.357c1.096-.05 1.426-.06 4.202-.06 2.777 0 3.107.01 4.204.06.66.008 1.313.129 1.932.357a3.442 3.442 0 0 1 1.975 1.975c.229.618.35 1.272.357 1.931.05 1.098.06 1.426.06 4.204 0 2.778-.01 3.107-.06 4.204a5.77 5.77 0 0 1-.357 1.932 3.443 3.443 0 0 1-1.975 1.974 5.743 5.743 0 0 1-1.932.356c-1.096.05-1.425.06-4.204.06-2.777 0-3.106-.01-4.202-.06zM11.741 5.72a7.628 7.628 0 0 0-2.526.483 5.318 5.318 0 0 0-3.042 3.042 7.63 7.63 0 0 0-.483 2.526c-.052 1.109-.063 1.464-.063 4.289 0 2.825.012 3.179.063 4.288a7.63 7.63 0 0 0 .483 2.526 5.318 5.318 0 0 0 3.042 3.042 7.636 7.636 0 0 0 2.526.483c1.11.05 1.463.063 4.288.063 2.826 0 3.18-.012 4.29-.063a7.631 7.631 0 0 0 2.525-.483 5.32 5.32 0 0 0 3.042-3.042 7.61 7.61 0 0 0 .483-2.526c.05-1.11.062-1.463.062-4.288s-.012-3.18-.062-4.289a7.629 7.629 0 0 0-.483-2.526 5.32 5.32 0 0 0-3.041-3.042 7.617 7.617 0 0 0-2.526-.483c-1.11-.05-1.464-.063-4.288-.063-2.825 0-3.18.012-4.29.063",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "nieromsd5b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.812 29.387) scale(35.5496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FA8F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D82D7E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "1ke9xy8usc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.395 28.488) scale(31.284)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8C3AAA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3AAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54e1fctlza"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColor);
export default __webpack_public_path__ + "static/media/InstagramColor.561b77692f0b801e23310b3e61bb43c3.svg";
export { ForwardRef as ReactComponent };